export const toHTML =  (data)=>{
  return `
 <!DOCTYPE html>
  <html lang="en">
  <head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Document</title>
    <style>
        *{
            margin: 0;
            padding: 0;
            font-family:"Microsoft Yahei";
        }
        body{
          width: 375px;
          margin: 0 auto;
        }
        .background-box {
            width: 375px;
            height: 603px;
            background-image: url("https://files.wondercv.com/m/jobs-share/background.png");
            background-repeat: no-repeat;
            background-size: 100%;
            box-sizing: border-box;
            padding: 123px 35px 74px;
            display: -webkit-box;
            display: -ms-flexbox;
            display: -webkit-flex;
            display: flex;
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -ms-flex-direction: column;
            flex-direction: column;
        }

        .hr-box {
            display: -webkit-box;
            display: -ms-flexbox;
            display: -webkit-flex;
            display: flex;
            align-items: center;
            margin-bottom: 5px;

        }

        .hr-avatar {
            width: 52px;
            height: 52px;
            border-radius: 50%;
            margin-right: 14px;
        }

        .hr-name {
            font-size: 16px;
            font-weight: 500;
            color: #404040;
            line-height: 22px;
            margin-bottom: 2px;
        }

        .hr-post {
            font-size: 14px;
            font-weight: 400;
            color: #404040;
            line-height: 20px;
        }

        .content-box {
            width: 305px;
            height: 72px;
            background-image: url("https://files.wondercv.com/m/jobs-share/content.png");
            background-repeat: no-repeat;
            background-size: 100%;
            box-sizing: border-box;
            padding: 19px 17px 13px;
            font-size: 14px;
            font-weight: 400;
            color: #404040;
            line-height: 20px;
            margin-bottom: 39px;
        }

        .job-desc-box {
            flex: 1;
            -webkit-box-flex: 1;
            -ms-flex-positive: 1;
            flex-grow: 1;
        }

        .job-name {
            font-size: 22px;
            font-weight: 600;
            color: #404040;
            line-height: 30px;
            margin-bottom: 4px;
        }

        .job-salary {
            font-size: 22px;
            font-weight: 600;
            color: #FF6644;
            line-height: 26px;
        }

        .job-other>span {
            font-size: 16px;
            font-weight: 400;
            color: #404040;
            line-height: 26px;
            position: relative;
            padding-right: 17px;


        }

        .job-other>span::after {
            content: "";
            height: 11px;
            width: 1px;
            background: #CFCFCF;
            position: absolute;
            right: 7px;
            top: 4px;
        }

        .job-other>span:last-child::after {
            height: 0px;
        }
        .job-share-content-box {
            height: 82px;
            display: -webkit-box;
            display: -ms-flexbox;
            display: -webkit-flex;
            display: flex;
            -webkit-box-pack: justify;
            -ms-flex-pack: justify;
            justify-content: space-between;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
        }
        .hint-box {
            width: 103px;
            height: 23px;
            background: #FFFFFF;
            border-radius: 2px;
            border: 1px solid #FF6644;
            box-sizing: border-box;
            text-align: center;
            font-size: 13px;
            font-weight: 400;
            color: #FF6644;
            margin-bottom: 6px;
            line-height: 21px;
        }

        .hint-text {
            font-size: 13px;
            font-weight: 400;
            color: #606060;
            line-height: 18px;
        }

        .code-box {
            width: 82px;
            height: 82px;
            /*background: #F4F4F4;*/
            background-image: url('${data.code}');
            background-size: 100%;
            ::v-deep img {
                width: 82px;
                height: 82px;
            }
        }
    </style>
</head>

<body>
    <div class="background-box" id="job-share-card">
        <div class="hr-box">
            <img class="hr-avatar"
                src="${data.hr.hr_avatar}"
                alt="">
            <div>
                <p class="hr-name">${data.hr.hr_name}</p>
                <p class="hr-post">${data.company.company_nick_name} · ${data.hr.company_position}</p>
            </div>
        </div>
        <div class="content-box">
            求${data.job.experience}${data.job.job_post}一枚，推荐自荐都感恩，base${data.job.city}~
        </div>
        <div class="job-desc-box">
            <p class="job-name">${data.job.job_post}</p>
            <p class="job-salary">${data.job.salary}${ !!data.job.annual_month_salary && data.job.annual_month_salary > 12 ? ' · ' + data.job.annual_month_salary + '<span style="font-size: 18px;margin-left:4px;">薪</span>': ''}</p>
            <p class="job-other">
              <span>${data.job.city || ''}</span>
              <span>${data.job.experience || ''}</span>
              <span>${data.job.degree || ''}</span>
            </p>
        </div>
        <div class="job-share-content-box">
            <div>
                <div class="hint-box">
                    长按识别二维码
                </div>
                <p class="hint-text">进入超级简历查看职位详情</p>
            </div>
            <div class="code-box"> 
            </div>
        </div>

    </div>
</body>

</html>
  `
}

export const getCutImageUrl = (url) => {
  return new Promise(resolve =>{
    let loadTimer = 0;
    let imgObject = new Image();
    imgObject.setAttribute('crossOrigin', 'anonymous');
    imgObject.src = url;
    const onImgLoaded = () => {
      if (loadTimer != null) clearTimeout(loadTimer);
      if (!imgObject.complete) {
        loadTimer = setTimeout( ()=> {
          onImgLoaded();
        }, 3);
      } else {
        let imageUrl = cutImage(imgObject, 1125, 1809, 287.5, 0, 1 )
        resolve(imageUrl)
      }
    }
    imgObject.onLoad = onImgLoaded()
  })

}

//裁剪图片
export const cutImage = (imgObj, newWidth, newHeight, startX, startY, ratio) => {
  let tnCanvas = document.createElement('canvas');
  let tnCanvasContext = tnCanvas.getContext('2d');
  tnCanvas.width = newWidth; tnCanvas.height = newHeight;

  /* use the sourceCanvas to duplicate the entire image. This step was crucial for iOS4 and under devices. Follow the link at the end of this post to see what happens when you don’t do this */
  let bufferCanvas = document.createElement('canvas');
  let bufferContext = bufferCanvas.getContext('2d');
  bufferCanvas.width = imgObj.width;
  bufferCanvas.height = imgObj.height;
  bufferContext.drawImage(imgObj, 0, 0);

  /* now we use the drawImage method to take the pixels from our bufferCanvas and draw them into our thumbnail canvas */
  tnCanvasContext.drawImage(bufferCanvas, startX, startY, newWidth * ratio, newHeight * ratio, 0, 0, newWidth, newHeight);
  return tnCanvas.toDataURL();
}
